import styled from 'styled-components';

const Title = styled.h1`
  width: 100%;
  text-align: center;
  font-size: 1.625rem;
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  line-height: 1.2;
  margin: 0;
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';

  ${Styles.desktop`
    font-size: 2rem;
    margin-top: 2.5rem;
  `}
`;

export default Title;
